
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid]",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid]"])
      });
    }
  